/* tslint:disable */

declare var Object: any;
export interface LessonChallengeTimelineInterface {
  "lessonId": number;
  "challengeTimelineId": number;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class LessonChallengeTimeline implements LessonChallengeTimelineInterface {
  "lessonId": number;
  "challengeTimelineId": number;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: LessonChallengeTimelineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LessonChallengeTimeline`.
   */
  public static getModelName() {
    return "LessonChallengeTimeline";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LessonChallengeTimeline for dynamic purposes.
  **/
  public static factory(data: LessonChallengeTimelineInterface): LessonChallengeTimeline{
    return new LessonChallengeTimeline(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LessonChallengeTimeline',
      plural: 'LessonChallengeTimelines',
      path: 'LessonChallengeTimelines',
      idName: 'id',
      properties: {
        "lessonId": {
          name: 'lessonId',
          type: 'number'
        },
        "challengeTimelineId": {
          name: 'challengeTimelineId',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
